import { useEffect } from 'react'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { useWatch } from 'react-hook-form'
interface ReturnType {
  handlePhaseChange: () => void
  handleCheckboxChange: (checked: boolean) => void
  handleMainProtectionChange: (newValue: number | string) => void
  hasEmc: boolean
  hasElectricalCurrentTransformer: boolean | undefined
}

export const useElectricalGridSettings = (): ReturnType => {
  const { control, setValue, getValues, resetField, trigger } = useInstallationForm()

  const [emcDevice, mainProtection, hasElectricalCurrentTransformer] = useWatch({
    control,
    name: ['emcDevice', 'generalSettings.gridSettings.mainProtection', 'generalSettings.gridSettings.gridMeter.hasElectricalCurrentTransformer'],
  })

  const hasEmc = emcDevice !== null

  useEffect(() => {
    if (hasEmc) return
    // reset the fields if EMC is removed
    resetField('generalSettings.gridSettings.gridMeter.hasElectricalCurrentTransformer')
    resetField('generalSettings.gridSettings.gridMeter.electricalCurrentTransformerRatio')
  }, [hasEmc, resetField])

  // Revalidate thermal derating and charging stations when mainProtection changes.
  useEffect(() => {
    trigger('generalSettings.gridSettings.thermalDerating')
    trigger('chargingStations')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainProtection])

  const handleMainProtectionChange = (newValue: number | string): void => {
    const value = Number(newValue)
    const newThermalDerating = Math.round(value * 0.8)
    setValue('generalSettings.gridSettings.thermalDerating', newThermalDerating, {
      shouldDirty: true,
    })
  }

  const handlePhaseChange = (): void => {
    const modbusTcpEvse = getValues('chargingStations.modbusTcp')
    modbusTcpEvse.forEach((_evse, index) => {
      setValue(`chargingStations.modbusTcp.${index}.phaseManagement`, '1PhBlocked', { shouldDirty: true })
      setValue(`chargingStations.modbusTcp.${index}.phaseMapping`, '123', {
        shouldDirty: true,
      })
    })
  }

  const handleCheckboxChange = (checked: boolean): void => {
    setValue('generalSettings.gridSettings.gridMeter.electricalCurrentTransformerRatio', checked ? '400:5' : '1:1', {
      shouldDirty: true,
    })
  }
  return {
    handlePhaseChange,
    handleCheckboxChange,
    handleMainProtectionChange,
    hasEmc,
    hasElectricalCurrentTransformer,
  }
}
